import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { V2L2WorkItemDetailContent, V2L2WorkItemDetailRoot, V2L2WorkItemDetailTitle } from "./V2L2WorkItemDetail"
import { V2L2WorkItemDetailContentItem } from "./V2L2WorkItemDetailContentItem"
import { faBan } from '@fortawesome/pro-regular-svg-icons'

interface V2L3WorkItemCancelledDetailProps {
	title: string
}

export const V2L3WorkItemCancelledDetail = ({title}: V2L3WorkItemCancelledDetailProps) => {
	return (
		<V2L2WorkItemDetailRoot>
			<V2L2WorkItemDetailTitle ready={false}>
				<FontAwesomeIcon icon={faBan} />
				{title}
			</V2L2WorkItemDetailTitle>
			<V2L2WorkItemDetailContent>
				<V2L2WorkItemDetailContentItem label="Notice" span={3}>
					This appointment has been cancelled.  For assistance, please contact support.
				</V2L2WorkItemDetailContentItem>
			</V2L2WorkItemDetailContent>
		</V2L2WorkItemDetailRoot>
	)
}
